(function () {
  'use strict';

  function initDisplayTitle() {
    var mapEl = document.querySelector('.js-variant-display-titles');
    if (!mapEl) return;

    var titles = {};
    try {
      titles = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    var titleEls = document.querySelectorAll('.js-product-display-title');
    if (!titleEls.length) return;

    var forms = document.querySelectorAll(
      'article.js-product .js-product-form, sticky-bar .js-product-form, form.js-product-form.quick-view'
    );

    function getVariantInput() {
      var mainForm = document.querySelector('article.js-product .js-product-form-main');
      if (mainForm) {
        var mainInput = mainForm.querySelector('input[name="id"]');
        if (mainInput && mainInput.value) return mainInput;
      }

      for (var i = 0; i < forms.length; i++) {
        var input = forms[i].querySelector('input[name="id"]');
        if (input && input.value) return input;
      }

      return null;
    }

    var lastVariantId = null;

    function updateTitle() {
      var variantInput = getVariantInput();
      if (!variantInput) return;

      var variantId = variantInput.value;
      if (!variantId || !titles[variantId]) return;

      titleEls.forEach(function (el) {
        el.textContent = titles[variantId];
      });
    }

    function checkVariantChange() {
      var variantInput = getVariantInput();
      if (!variantInput) return;

      if (variantInput.value === lastVariantId) return;
      lastVariantId = variantInput.value;
      updateTitle();
    }

    function watchVariantInput(input) {
      if (!input) return;

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            setTimeout(checkVariantChange, 50);
          }
        });
      }).observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    forms.forEach(function (form) {
      watchVariantInput(form.querySelector('input[name="id"]'));

      form.addEventListener('change', function (e) {
        if (!form.contains(e.target)) return;
        if (e.target.classList.contains('js-product-option') || e.target.name === 'id') {
          setTimeout(checkVariantChange, 100);
        }
      }, true);

      form.addEventListener('click', function (e) {
        var target = e.target;
        if (!form.contains(target)) return;
        if (target.classList.contains('js-product-option') || (target.closest && target.closest('.js-product-option'))) {
          setTimeout(checkVariantChange, 100);
        }
      }, true);
    });

    var initialInput = getVariantInput();
    if (initialInput) lastVariantId = initialInput.value;

    setInterval(checkVariantChange, 500);
    updateTitle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDisplayTitle);
  } else {
    initDisplayTitle();
  }

  window.addEventListener('load', initDisplayTitle);
})();
